export default __webpack_public_path__ + "3f76277bd8130f7bbb9bea58c4f11d49.svg";